import React, { Component } from 'react'
import { useSelector } from "react-redux"
import "./style.scss"

export default function FadeInSection(props) {
    // const [isVisible, setVisible] = React.useState(true);
    // const domRef = React.useRef();
    // React.useEffect(() => {
    //     const observer = new IntersectionObserver(entries => {
    //         entries.forEach(entry => setVisible(entry.isIntersecting));
    //     });
    //     observer.observe(domRef.current);
    //     return () => observer.unobserve(domRef.current);
    // }, []);
    // return (
    //     <div
    //         className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
    //         ref={domRef}
    //     >
    //         {props.children}
    //     </div>
    // );


    return (
        <div

        >
            {props.children}
        </div>
    )
}